<template>
  <div class="Poplist">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        商品排行
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;margin-bottom: 20px;">
        <el-row class="search">
          <el-col :span="2">
            <div class="label">商品名称:</div>
          </el-col>
          <el-col :span="5">
            <el-input clearable v-model="mobile" size="small" placeholder="输入商品名称"></el-input>
          </el-col>
          <el-col :span="16" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <router-link to="./c_addPoputy" tag="div" class="center_list_head_rig">添加商品</router-link>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <!-- <el-table-column label width="40" v-model="select" type="selection"></el-table-column> -->
        <el-table-column prop="id" width="100" label="编号" align="center"></el-table-column>
        <el-table-column prop="title" label="商品名称" align="center"></el-table-column>

        <el-table-column prop="views" label="浏览量" align="center"></el-table-column>
        <el-table-column prop="classification" label="分类" align="center"></el-table-column>
        <el-table-column label="操作" width="150" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="del(scope.row.id)" class="button1">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col :span="2" style="padding-left:10px;">
            <!-- <el-checkbox v-model="selectAll" style="line-height: 34px">全选</el-checkbox> -->
          </el-col>

          <el-col style="margin:0 auto">
            <el-pagination
              style="text-align:center"
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            >1</el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      options: [],
      token: "",
      username: "",
      page: "",
      total: 0,
      tableData: [],
      mobile: "",
      select: false,
      selectAll: false
    };
  },
  created() {
    this.$store.state.leftTitle = "商品排行";
    this.$store.state.topActiveId = 5;
    this.geting();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    shipments(id) {
      //确认发货弹窗

      const _this = this;
      this.axios
        .get(this.serve + "/admin/express_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          _this.option = [];
          var json = res.data.data.results;
          _this.id = id;
          for (var key in json) {
            if (json[key].status == "1") {
              _this.option.push(json[key]);
            }
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error("添加失败");
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "添加成功",
        type: "success"
      });
    },
    submit(id) {
      //弹窗提交

      for (var key in this.tableData) {
        if (this.odd === this.tableData[key].mobile) {
          this.$message.error("此账号已存在");
          return;
        }
      }
      if (this.odd == "") {
        this.$message.error("请输入用户账号");
        return;
      } else if (this.odd !== "") {
        var cel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!cel.test(this.odd)) {
          this.$message.error("账号为手机号码");
          return;
        }
      }
      if (this.password == "") {
        this.$message.error("请输入密码");
        return;
      } else if (this.password !== "") {
        var pass = /^[A-Za-z0-9]{6,20}$/;
        if (!pass.test(this.password)) {
          this.$message.error("登陆密码最小为6位数，最大为20位数");
          return;
        }
      }
      if (this.password1 != this.password) {
        this.$message.error("两次输入密码不一致");

        return;
      }
      if (this.odd || this.password || this.password1) {
        this.dialogFormVisible1 = false;
      }
      const _this = this;

      this.axios
        .get(this.serve + "/admin/create_home_user", {
          params: {
            username: this.username,
            token: this.token,
            mobile: this.odd,
            password: this.password,
            new_pass: this.password1
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            _this.open();
            _this.geting();
          } else if (res.data.status == "error") {
            _this.open4();
          }
        });
    },
    red(id) {
      this.$router.push({
        path: "y_userLook?id=" + id
      });
    },
    del(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/delete_hot", {
              params: {
                username: this.username,
                token: this.token,
                product_id: id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.geting();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg); 
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
    },

    setPage(v) {
      //分页

      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },
    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/hot_list", {
          params: {
            username: this.username,
            token: this.token,
            page: this.page,
            product: this.mobile
          }
        })
        .then(res => {
          var json = res.data.data;
          this.tableData = [];
          if (res.data.status == "success") {
            this.page = json.page;
            this.total = json.total;
            for (var key in json.results) {
              this.tableData.push(json.results[key]);
            }
          }else{
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.Poplist {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>